function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useState, useEffect } from "react";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Alert, Image, QRCode, Space } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import DocumentHeader from "./DocumentHeader";
import DocumentFooter from "./DocumentFooter";
import { Parser } from 'html-to-react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LaboratorySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var queue_item = _ref.queue_item;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      ItemsList = _useState2[0],
      setItemsList = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      uncategorisedItemsList = _useState4[0],
      setUncategorisedItemsList = _useState4[1];

  var groupByService = function groupByService(items) {
    return Object.values(items.reduce(function (acc, item) {
      var businessAccountMedicalItemCategoryId = item.business_account_medical_item_category_id;

      if (!acc[businessAccountMedicalItemCategoryId]) {
        acc[businessAccountMedicalItemCategoryId] = _defineProperty(_defineProperty({
          business_account_medical_item_category_label: item.business_account_medical_item_category_label,
          sample_id: item.sample_id,
          item_label: item.item_label,
          result: item.result,
          normal_value: item.normal_value,
          business_account_medical_item_category_id: item.business_account_medical_item_category_id
        }, "business_account_medical_item_category_label", item.business_account_medical_item_category_label), "items", []);
      }

      acc[businessAccountMedicalItemCategoryId].items.push(item);
      return acc;
    }, {}));
  };

  useEffect(function () {
    setItemsList([]);
    queue_item && queue_item.queue_item_elements.forEach(function (e) {
      if (e.laboratory_result && e.business_account_medical_item) {
        if (e.business_account_medical_item.business_account_medical_item_category) setItemsList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            sample_id: e.laboratory_result.sample_id,
            item_label: e.business_account_medical_item.label,
            result: e.laboratory_result.result_string,
            normal_value: e.laboratory_result.normal_value,
            business_account_medical_item_category_id: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category_id : 0,
            business_account_medical_item_category_label: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category.label : "AUTRES"
          }]);
        });
        if (e.business_account_medical_item.business_account_medical_item_category == null) setUncategorisedItemsList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            sample_id: e.laboratory_result.sample_id,
            item_label: e.business_account_medical_item.label,
            result: e.laboratory_result.result_string,
            normal_value: e.laboratory_result.normal_value,
            business_account_medical_item_category_id: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category_id : 0,
            business_account_medical_item_category_label: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category.label : "AUTRES"
          }]);
        });
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        style: {
          padding: "20px"
        },
        children: [/*#__PURE__*/_jsx(DocumentHeader, {
          title: "FICHE DE LABORATOIRE"
        }), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: /*#__PURE__*/_jsxs(Table, {
              bordered: true,
              responsive: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "N.Echantillon"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Examen"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Resultat"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Valeur normale"
                  })]
                })
              }), /*#__PURE__*/_jsxs("tbody", {
                children: [groupByService(ItemsList).map(function (group, index) {
                  return /*#__PURE__*/_jsxs(React.Fragment, {
                    children: [/*#__PURE__*/_jsx("tr", {
                      className: "table-secondary",
                      children: /*#__PURE__*/_jsx("td", {
                        colSpan: 4,
                        children: /*#__PURE__*/_jsx("strong", {
                          children: group.business_account_medical_item_category_label
                        })
                      })
                    }), group.items.map(function (item) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: item.sample_id
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.item_label
                        }), /*#__PURE__*/_jsx("td", {
                          children: Parser().parse(item.result)
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.normal_value
                        })]
                      }, item.id);
                    })]
                  }, index);
                }), groupByService(uncategorisedItemsList).map(function (group, index) {
                  return /*#__PURE__*/_jsxs(React.Fragment, {
                    children: [/*#__PURE__*/_jsx("tr", {
                      className: "table-secondary",
                      children: /*#__PURE__*/_jsx("td", {
                        colSpan: 4,
                        children: /*#__PURE__*/_jsx("strong", {
                          children: group.business_account_medical_item_category_label
                        })
                      })
                    }), group.items.map(function (item) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: item.sample_id
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.item_label
                        }), /*#__PURE__*/_jsx("td", {
                          children: Parser().parse(item.result)
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.normal_value
                        })]
                      }, item.id);
                    })]
                  }, index);
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Responsable du Laboratoire"
              })
            })
          })
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(DocumentFooter, {})]
  });
});
export default LaboratorySheet;